export default __webpack_public_path__ + "assets/e56ec64590c9d1fc4fa4f38aea35165b-flyer.png";